"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listPreAuthsQuerySchema = exports.bindPreAuthSchema = exports.closePreAuthSchema = exports.pendingPreAuthSchema = exports.submitPreAuthSchema = exports.requestPreAuthDeskSchema = exports.ipPreAuthAdmissionTypeEnum = void 0;
const zod_1 = require("zod");
const ip_insurance_schema_1 = require("./ip-insurance.schema");
/**
 * INSURANCE MODULE, PHASE 2 (ADR-098) — the pre-authorisation desk.
 *
 * Approve, enhance and reject reuse the ADR-085 schemas unchanged (their bodies
 * are exactly what the desk records). What is new here is the REQUEST — which
 * now carries the clinical facts an insurer needs and names no insurer at all,
 * because the policy already does — and the small acts around it.
 *
 * Amounts are integer paise.
 */
exports.ipPreAuthAdmissionTypeEnum = zod_1.z.enum(['PLANNED', 'EMERGENCY', 'DAY_CARE']);
exports.requestPreAuthDeskSchema = zod_1.z.object({
    /** The policy. Insurer, plan and TPA are read from it. */
    patientCoverageId: zod_1.z.string().uuid(),
    /** Omit for a planned case approved before arrival; it is attached at admit. */
    ipAdmissionId: zod_1.z.string().uuid().optional(),
    requestedAmount: zod_1.z.number().int().positive().max(100_000_000_000),
    externalReference: zod_1.z.string().trim().max(100).optional(),
    diagnosis: zod_1.z.string().trim().max(2000).optional(),
    /** ICD-10, e.g. K35.8 or I21. Letter, then digits, optional dot and more. */
    icdCode: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Za-z][0-9][0-9A-Za-z](\.[0-9A-Za-z]{1,4})?$/, 'ICD-10 code looks like K35 or K35.8')
        .optional(),
    plannedProcedure: zod_1.z.string().trim().max(2000).optional(),
    admissionType: exports.ipPreAuthAdmissionTypeEnum.optional(),
    plannedAdmissionOn: zod_1.z.coerce.date().optional(),
    expectedStayDays: zod_1.z.number().int().min(1).max(365).optional(),
    roomCategory: zod_1.z.string().trim().max(60).optional(),
    treatingDoctorId: zod_1.z.string().uuid().optional(),
    treatingDoctorName: zod_1.z.string().trim().max(150).optional(),
});
exports.submitPreAuthSchema = zod_1.z.object({ reference: zod_1.z.string().trim().max(100).optional() });
exports.pendingPreAuthSchema = zod_1.z.object({ reason: zod_1.z.string().trim().max(1000).optional() });
exports.closePreAuthSchema = zod_1.z.object({ reason: zod_1.z.string().trim().max(1000).optional() });
exports.bindPreAuthSchema = zod_1.z.object({ ipAdmissionId: zod_1.z.string().uuid() });
exports.listPreAuthsQuerySchema = zod_1.z.object({
    /** Comma-separated statuses, e.g. `REQUESTED,SUBMITTED,PENDING`. */
    status: zod_1.z
        .string()
        .transform((v) => v.split(',').map((x) => x.trim()).filter(Boolean))
        .pipe(zod_1.z.array(ip_insurance_schema_1.ipPreAuthStatusEnum).max(9))
        .optional(),
    /** Patient name, UHID or pre-auth number. */
    q: zod_1.z.string().trim().max(100).optional(),
    /** `true` = only requests not yet attached to a stay. */
    unbound: zod_1.z.enum(['true', 'false']).optional(),
    coverageId: zod_1.z.string().uuid().optional(),
    admissionId: zod_1.z.string().uuid().optional(),
    page: zod_1.z.coerce.number().int().min(1).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(200).optional(),
});
//# sourceMappingURL=insurance-preauth.schema.js.map